<template>
  <div>
    <div
      v-for="(setParams, setIndex) in sets"
      :key="'set'+setIndex"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block"
        style="width: 50px"
        :class="{ 'caption': dense, 'text-body-1': !dense }"
      >
        {{ $t("training_builder.configure.set", {set: setIndex + 1}) }}:
      </div>

      <exercise-param-label-helper
        :label="$t('reps.label')"
        :dense="dense"
        :param="setParams.NMRP"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.interval_distance.title')"
        :dense="dense"
        :param="getDistance(setParams.INTDST)"
        :suffix="distanceSuffix(user.organisation_settings.unit_system)"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.interval_duration.title')"
        :dense="dense"
        :param="setParams.INTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('rest_after_set.label')"
        :dense="dense"
        :param="setParams.RSSTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.dropdown.resistance_type.title')"
        :dense="dense"
        :param="setParams.RSTTP"
      />

      <exercise-param-label-helper
        v-if="setParams.RSTTP === 'Parachutes'"
        :label="$t('training_builder.text_input.tether_length.title')"
        :dense="dense"
        :param="getDistance(setParams.TTHLNG)"
        :suffix="distanceSuffix(user.organisation_settings.unit_system)"
      />
    </div>
  </div>
</template>
<script>

import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'
import { convertDistanceByUnitSystem, distanceSuffix } from '@/components/training-builder/helpers'

export default {
  name: 'SwimmingParamsView',
  components: { ExerciseParamLabelHelper },
  props: {
    sets: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  },
  methods: {
    distanceSuffix,
    getDistance(param) {
      if (param && typeof param === 'object' && 'def' in param) {
        return {
          def: convertDistanceByUnitSystem(param.def, this.user.organisation_settings.unit_system, true),
          real: convertDistanceByUnitSystem(param.real, this.user.organisation_settings.unit_system, true)
        }
      }

      if (!param) return null

      return convertDistanceByUnitSystem(param, this.user.organisation_settings.unit_system, true)
    }
  }
}
</script>
